const deepReorder = (array, id, fn) => {
  const itemWithId = array.find(item => item.id === id);

  if (itemWithId) {
    const arrayWithoutItem = array.filter(item => item.id !== id);

    return fn(itemWithId, arrayWithoutItem);
  }

  return array.map(item => (
    item.navigationItems
      ? { ...item, navigationItems: deepReorder(item.navigationItems, id, fn) }
      : item
  ));
};

export default deepReorder;
